import { LegalPageLayout, LegalSections } from "../components/LegalPageLayout";

export default function Terms() {
  return (
    <LegalPageLayout pageKey="terms">
      <LegalSections pageKey="terms" />
    </LegalPageLayout>
  );
}
